<!-- 
卡密领取
Card={
    gainId: 0,
    isCharge: false,
    isUsed: false,
    isGain: false,
    createTime: 1529572282848,
    useTime: 1529572282848,
    vproductType: 'fullnet-vir-net',
    cardInfo: {
        cardId: '80323',
        cardNo: '16881519719784038007',
        cardPwd: 'GL26PHkb5LTK9G7e',
        expireDate :"2019-02-27",
        vproductName:"全网2G流量卡",
    }
}
-->

<template>
<transition name="modal-fade">
    <div class="modal-backdrop" >
        <div class="modal" >
            <div class="modal-title">
                <slot name="header">卡密领取</slot>
                <img class="close" @click="close" src="http://res.uuudian.com/hk_data/1c90d459-3a56-4646-a43b-08296ea54f4d" alt="">
            </div>
            <div class="modal-body">
                <slot name="body">
                    <div class="content">
                        <img src="http://res.uuudian.com/hk_data/58fc3db6-5997-4049-b99a-950fa55c002d" alt="">
                        <div class="item">
                            <p class="cardno" :data-clipboard-text="cardInfo.number" @click="copy">{{cardInfo.number}}</p>
                            <p class="tips">点击卡号直接复制</p>
                        </div>
                        <div class="item">
                            <p class="cardno" :data-clipboard-text="cardInfo.secret">{{cardInfo.secret}}</p>
                            <p class="tips">点击提货码直接复制</p>
                        </div>
                    </div>
                </slot>
            </div>
            <div class="modal-footer">
                <slot name="footer">
                    <div class="m-btn-group">
                        <template v-if="cardInfo.cardProtoCode == 'fullnet-vir-net'">
                            <span class="copy-all" :data-clipboard-text="allInfo" @click="copyAll">全部复制</span>
                            <span @click="ToCharge">去充值</span>
                        </template>
                        <template v-if="cardInfo.cardProtoCode == 'shangwang'">
                            <span class="copy-all" :data-clipboard-text="allInfo" @click="copyAll">全部复制</span>
                            <span @click="ToPickUp">去提货</span>
                        </template>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</transition>
</template>
<script>
import Verify from '@/components/orders/verify'
import Clipboard from 'clipboard';

export default {
    props: ["card"],
    components: {Verify},
    data() {
        return {
            cardInfo: this.card,
            allInfo: '',

        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        copy() {
            var clipboard = new Clipboard('.cardno')
            clipboard.on('success', e => {
                this.$toast('复制成功')
                // 释放内存
                clipboard.destroy()
            })
        },

        copyAll () {
            var clipboard = new Clipboard('.copy-all');
            var info = '卡号：' + this.cardInfo.number + ' / ' + '密码：' + this.cardInfo.secret;
            this.allInfo = info;
            clipboard.on('success', e => {
                this.$toast('复制成功')
                // 释放内存
                clipboard.destroy()
            })
        },
        ToCharge () {
            alert('去充值')
        },
        ToPickUp () {
            alert('去提货')
        }
    }
}
</script>
<style scoped lang="less">
.modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

.modal {
    background-color: #fff;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 88.2666vw;
    border-radius: 5px;
    p {
        margin: 0
    }
}

.modal-title {
    text-align: center;
    padding: 6vw;
    border-bottom: 1px solid #e5e5e5;
    font-size: 4.2666vw;
    color: #3c3c3c;
    position: relative;
    .close {
        width: 3vw;
        position: absolute;
        right: 5vw;
        top: 7.5vw;
    }
}

.modal-fade-enter,
.modal-fade-leave-active {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .3s ease
}

.content {
    padding: 5vw;
  img {
    width: 100%;
    margin-bottom: 2vw;
  }

  .item {
    margin-bottom: 5vw;
    padding: 0 3vw;
  }

  .cardno {
    font-size: 3.8vw;
    color: #333;
    margin-bottom: 1vw;
  }
  .tips {
    color: #999;
    font-size: 3vw;
  }
}

.m-btn-group {
  display: flex;
  justify-content: center;
  border-top: 1px solid #e5e5e5;

  span {
    flex: 1;
    text-align: center;
    padding: 4vw 0;
    font-size: 4vw;
  }
  span:first-child {
    border-right: 1px solid #e5e5e5;
  }
  span:last-child {
    background: linear-gradient(to right, #fe0229, #fe7d5d);
    color: #fff;
    border-bottom-right-radius: 5px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/orders/CardGet.vue